<template>
  <div>
    <div class="heading">
      <h3 class="mb-s">{{ $t('title.changePassword') }}</h3>
      <div class="line-height-s">
        {{subTitle}}
      </div>
    </div>
    <ChangePasswordForm :isLoading="isLoading" @submit="handleSubmit"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import userServices from '@/services/user';
import { setToken } from '@/utils/common';

const ChangePasswordForm = () => import('@/components/forms/ChangePasswordForm');

export default {
 name: 'ChangePasswordExpire',
 props: {
   password: {
     type: String,
     default: '',
   },
   errorMessage: {
    type: String,
    default: '',
   },
 },
 components: {
  ChangePasswordForm,
 },
 data() {
  return {
    apiAccessToken: process.env.VUE_APP_API_ACCESS_TOKEN_KEY || 'access_token',
    isLoading: false,
    oldPassword: '',
  };
 },
 computed: {
    ...mapGetters('device', [
      'isMobile',
    ]),
    subTitle() {
      return this.errorMessage || this.$t('title.tempPasswordExpired');
    },
  },
  beforeMount() {
    if (!this.password) {
      this.$emit('goToStep', 'step-2');
    }
  },
  methods: {
    async handleSubmit(data) {
      const payload = {
        new_password: data.newPassword,
        old_password: this.password,
      };
      try {
        this.isLoading = true;
        const response = await userServices.updatePassword(payload);
        // update access token
        if (response?.[this.apiAccessToken]) {
          setToken(response[this.apiAccessToken]);
        }
        this.isLoading = false;
        this.$notify({
          title: this.$t('notification.success.title'),
          message: response?.message,
          type: 'success',
          customClass: 'success',
        });
        this.$emit('goToStep', 'change-success-step');
        this.$emit('updateMessage', '');
      } catch (error) {
        this.isLoading = false;
      }
    },
  },
};
</script>
